import { Loader2, XCircle } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import {
  canDisqualifyCandidate,
  DISQUALIFY_COPY,
} from '@/lib/forkhire/workflow/candidateDisqualification';

interface DisqualifyCandidateActionProps {
  stage: string | null | undefined;
  disabled?: boolean;
  isPending?: boolean;
  reason?: string | null;
  onClick: () => void;
  compact?: boolean;
}

export function DisqualifyCandidateAction({
  stage,
  disabled = false,
  isPending = false,
  reason,
  onClick,
  compact = true,
}: DisqualifyCandidateActionProps) {
  if (!canDisqualifyCandidate(stage)) return null;

  const button = (
    <Button
      variant="outline"
      size={compact ? 'icon' : 'sm'}
      className={compact
        ? 'h-8 w-8 rounded-lg border-destructive/30 text-destructive hover:bg-destructive/5 hover:text-destructive'
        : 'gap-1.5 border-destructive/30 text-destructive hover:bg-destructive/5 hover:text-destructive'}
      disabled={disabled || isPending}
      onClick={onClick}
      aria-label={DISQUALIFY_COPY.actionLabel}
    >
      {isPending ? (
        <Loader2 className="w-4 h-4 animate-spin" />
      ) : (
        <XCircle className={compact ? 'w-4 h-4' : 'w-3.5 h-3.5'} />
      )}
      {!compact && <span>{DISQUALIFY_COPY.actionLabel}</span>}
    </Button>
  );

  return (
    <Tooltip>
      <TooltipTrigger asChild>{button}</TooltipTrigger>
      <TooltipContent side="top" className="text-xs">
        {disabled && reason ? reason : DISQUALIFY_COPY.actionLabel}
      </TooltipContent>
    </Tooltip>
  );
}
